import { createSelector } from 'reselect'

import { selectFinancialCockpitState } from './selectFinancialCockpitState'

export const selectCockpitOffering = createSelector(
  [selectFinancialCockpitState],
  ({ selectedOffering }) => selectedOffering
)
